var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "working-hours" }, [
    _vm.workingHours
      ? _c(
          "ul",
          { staticClass: "working-hours-list" },
          _vm._l(_vm.workingHours, function (workingHour, index) {
            return workingHour
              ? _c("li", { key: index, staticClass: "row" }, [
                  _c("div", { staticClass: "small-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(workingHour.workingDesc) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "working-day-from small-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.joinDayString(workingHour)) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small-3" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.joinHourString(workingHour)) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("button", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.disabled,
                        expression: "!disabled",
                      },
                    ],
                    staticClass: "fa fa-times fa-lg",
                    class: "delete-working-hour-" + index,
                    attrs: { role: "delete-button", "aria-hidden": true },
                    on: {
                      click: function ($event) {
                        return _vm.deleteWorkingHour(index)
                      },
                    },
                  }),
                ])
              : _vm._e()
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showWorkingHours && !_vm.disabled ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.disabled,
            expression: "!disabled",
          },
        ],
        staticClass: "working-hours-add",
      },
      [
        _c("InputField", {
          staticClass: "small-8",
          attrs: {
            value: _vm.workingDesc,
            required: true,
            placeholder: _vm.$t("hint.holidayHourPlaceholder"),
          },
          model: {
            value: _vm.workingDesc,
            callback: function ($$v) {
              _vm.workingDesc = $$v
            },
            expression: "workingDesc",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "working-hours-date-time row" },
          [
            _c("DatePicker", {
              staticClass: "working-day hkl-select",
              attrs: {
                format: "DD MMM YYYY",
                calendarButton: true,
                placeholder: _vm.$t("dateFrom"),
                required: true,
                disabled: _vm.disabledDatesForStartDate(_vm.workingDayTo),
                calendarButtonIcon: "fa fa-calendar",
              },
              model: {
                value: _vm.workingDayFrom,
                callback: function ($$v) {
                  _vm.workingDayFrom = $$v
                },
                expression: "workingDayFrom",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "dash" }),
            _vm._v(" "),
            _c("DatePicker", {
              staticClass: "working-day hkl-select",
              attrs: {
                format: "DD MMM YYYY",
                calendarButton: true,
                placeholder: _vm.$t("dateTo"),
                required: true,
                disabled: _vm.disabledDatesForEndDate(_vm.workingDayFrom),
                calendarButtonIcon: "fa fa-calendar",
              },
              model: {
                value: _vm.workingDayTo,
                callback: function ($$v) {
                  _vm.workingDayTo = $$v
                },
                expression: "workingDayTo",
              },
            }),
            _vm._v(" "),
            _c("HKLSelect", {
              staticClass: "working-hour-from",
              class: {
                "error-highlight":
                  _vm.invalidWorkingHour ||
                  (_vm.isMandatory && _vm.emptyWorkingHours),
              },
              attrs: {
                name: "workingHourFrom",
                value: _vm.workingHourFrom || undefined,
                options: _vm.workingHourFromHklOptions,
                showSearch: true,
                placeholder: "",
              },
              on: {
                change: function ($event) {
                  _vm.workingHourFrom = $event || ""
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "dash" }),
            _vm._v(" "),
            _c("HKLSelect", {
              staticClass: "working-hour-to",
              class: {
                "error-highlight":
                  _vm.invalidWorkingHour ||
                  (_vm.isMandatory && _vm.emptyWorkingHours),
              },
              attrs: {
                name: "workingHourTo",
                disabled: _vm.disableHourTo,
                value: _vm.workingHourTo || undefined,
                options: _vm.workingHourToHklOptions,
                showSearch: true,
                placeholder: "",
              },
              on: {
                change: function ($event) {
                  _vm.workingHourTo = $event || ""
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue btn-add add-working-hour",
                attrs: {
                  id: "modules-tenders-workingHours-add",
                  disabled: _vm.disableButton(),
                  type: "button",
                  role: "add-button",
                  name: "add-working-hour",
                },
                on: { click: _vm.addWorkingHour },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.add")) + "\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }